import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import BrandLogo from "@/components/marketing/BrandLogo";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send reset link");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-[6px] border border-[#E2E8F0] p-8 shadow-sm">
        <div className="mb-5"><BrandLogo size="md" /></div>
        <div className="w-12 h-12 rounded-[6px] bg-[#F97316]/12 text-[#F97316] flex items-center justify-center mb-5">
          <Mail className="w-6 h-6" />
        </div>
        {!sent ? (
          <>
            <h1 className="font-display font-extrabold text-2xl">Forgot your password?</h1>
            <p className="text-sm text-[#4B5563] mt-2">
              Enter your work email and we'll send you a reset link. The link expires in 30 minutes.
            </p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="text-sm font-medium block mb-1.5">Email</label>
                <input
                  data-testid="forgot-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full border border-[#E2E8F0] focus:border-[#F97316] focus:ring-2 focus:ring-[#F97316]/20 outline-none px-3 py-2.5 rounded-sm"
                  placeholder="you@company.com"
                />
              </div>
              <button
                data-testid="forgot-submit-button"
                type="submit"
                disabled={busy}
                className="btn-primary w-full disabled:opacity-60"
              >
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
          </>
        ) : (
          <>
            <h1 className="font-display font-extrabold text-2xl" data-testid="forgot-sent-heading">Check your inbox</h1>
            <p className="text-sm text-[#4B5563] mt-2">
              If <span className="font-mono">{email}</span> is a HelloSir.ai account, a reset link is on its way. The link expires in 30 minutes.
            </p>
            <p className="text-xs text-[#94A3B8] mt-4">
              Didn't get it? Check spam, or try again in a minute.
            </p>
          </>
        )}
        <Link
          to="/login"
          className="inline-flex items-center gap-1.5 text-sm text-[#4B5563] hover:text-[#0F1115] mt-6 font-medium"
          data-testid="forgot-back-to-login"
        >
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
